@if (imageUrl() && !imageLoadError()) {
  <img
    alt=""
    class="search-result-thumbnail-image__image"
    src="{{imageUrl()}}"
    (error)="onImageError()"
  />
} @else {
  <span class="search-result-thumbnail-image__icon">
    <mat-icon>{{ iconName() }}</mat-icon>
  </span>
}
